import { create } from 'zustand'
import { persist } from 'zustand/middleware'

import type { SessionView } from '../../domain/access'

type SessionState = {
  session: SessionView | null
  accessState: 'signed_out' | 'active' | 'revoked'
  participantPreview: boolean
  setSession: (session: SessionView) => void
  clearSession: () => void
  markRevoked: () => void
  setParticipantPreview: (active: boolean) => void
}

export const sessionStore = create<SessionState>()(
  persist(
    (set) => ({
      session: null,
      accessState: 'signed_out',
      participantPreview: false,
      setSession: (session) => set({ session, accessState: 'active', participantPreview: false }),
      clearSession: () => set({ session: null, accessState: 'signed_out', participantPreview: false }),
      markRevoked: () => set({ accessState: 'revoked', participantPreview: false }),
      setParticipantPreview: (participantPreview) => set({ participantPreview }),
    }),
    {
      name: 'caravan-private-session-v1',
      partialize: ({ session, accessState }) => ({ session, accessState }),
    },
  ),
)
